// extracted by mini-css-extract-plugin
module.exports = {"label":"CodeNotFound_label__1fRzK"};